import React from 'react';
import './Image.css';

const Image = props => {    

    return (
        <img 
            className='game-image'
            src={props.imageSrc}
            alt={props.altTitle}
            id={props.id}
            onClick={props.onClick}
        />
    )
}

export default Image;


// WEBPACK FOOTER //
// ./src/components/Image/Image.js